export const translations = {
    en: {
        login: 'LOGIN',
        reversed: 'REVERSED',
        upright: 'UPRIGHT',
        hexagram: 'HEXAGRAM',
        reversedMeaning: 'Reversed Meaning',
        uprightMeaning: 'Upright Meaning',
        hexagramMeaning: 'Hexagram Meaning',
        coreKeywords: 'Core Keywords',
        keyword1: 'Keyword 1',
        keyword2: 'Keyword 2',
        keyword3: 'Keyword 3',
        inputPlaceholderTarot: "How's My Financial Energy?",
        inputPlaceholderIChing: "Ask about the hexagram's wisdom...",
        deepReading: 'Deep Reading',
        fastReading: 'Fast Reading',
        insufficientCoins: "Insufficient coins. Please top up to continue.",
        transactionFailed: "Transaction failed. Please try again.",
        spiritsSilent: "The spirits are silent. Please try again.",
        connectionInterrupted: "Connection interrupted. Please try again.",
        thinking: "Thinking...",
        tarotGreeting: (cardName: string, isReversed: boolean) => `Hi there. This card often whispers of ${isReversed ? 'challenges' : 'new beginnings'}. Shall we explore what it reveals about your situation?`,
        ichingGreeting: (cardName: string) => `Greetings. The hexagram ${cardName} has appeared. This ancient wisdom speaks of transformation and balance. What would you like to understand about your path?`,
        tarotStatic: (cardName: string, isReversed: boolean) => `The ${cardName} ${isReversed ? 'reversed' : 'upright'} represents...`,
        ichingStatic: "This hexagram is associated with...",
        promptContextFast: (info: string, msg: string) => `Context: User drew/received ${info}. User asks: "${msg}". Provide a quick, concise answer. Summarize in a brief paragraph.`,
        promptContextDeep: (info: string, msg: string, wisdom: string) => `Context: User drew/received ${info}. User asks: "${msg}". Provide a deep, detailed mystical interpretation based on ${wisdom} wisdom.`,
        promptContextHistory: (info: string, msg: string, type: string, isFast: boolean) => `Context: User drew/received ${info}. Previous conversation history exists. User asks: "${msg}". Answer as a ${type}.${isFast ? ' Keep the response brief and concise, summarize in a short paragraph.' : ' Provide detailed mystical interpretation.'}`,
        languagePrompt: " Answer in English.",
        invalidCardType: "Invalid card type",
        selectLanguage: "Select Language",
        tarotQuestions: [
            "What does this card reveal about my current situation?",
            "How can I overcome the challenges ahead?",
            "What opportunities should I be aware of?",
            "What is blocking my progress right now?",
            "How can I improve my relationships?",
            "What should I focus on for personal growth?",
            "What energy surrounds my love life?",
            "How can I align with my higher self?",
            "What career path serves me best?",
            "How do I find inner peace?",
            "What message does my intuition have for me?",
            "How can I better manage my resources?",
            "What is the outcome if I take this risk?",
            "Who or what is influencing my current path?",
            "What should I let go of to move forward?",
        ],
        ichingQuestions: [
            "What does this hexagram reveal about my current situation?",
            "How can I overcome the challenges ahead?",
            "What opportunities should I be aware of?",
            "What lesson is the universe teaching me?",
            "How can I find more balance in my life?",
            "What hidden potential do I have?",
            "What is the best course of action right now?",
            "How should I navigate this relationship?",
            "What changes are approaching in my career?",
            "How can I cultivate better luck?",
            "What is the underlying cause of this situation?",
            "How can I best adapt to these changes?",
            "What is the wise approach to this conflict?",
            "How does this situation align with my destiny?",
            "What small step can I take today for big results?",
        ],
        // NfcRead page
        scanText1: "PLACE CARD BEHIND PHONE",
        scanText2: "AND SENSE ITS ENERGY",
        tapToToggle: "TAP TO TOGGLE UPRIGHT/REVERSED",
        confirmButton: "CONFIRM AND START READING",

        // Auth page
        authOnlineDivination: "ONLINE DIVINATION",
        authWelcomeBack: "Welcome back",
        authCreateAccount: "CREATE ACCOUNT",
        authWelcome: "Welcome",
        authEmailLabel: "Email Address",
        authEmailPlaceholder: "your@gmail.com",
        authPasswordLabel: "Password",
        authPasswordPlaceholder: "Enter your password",
        authLogIn: "LOG IN",
        authLoggingIn: "LOGGING IN...",
        authSignUp: "SIGN UP",
        authSigningUp: "SIGNING UP...",
        authGoogle: "GOOGLE",
        authAppleId: "APPLE ID",
        authNoAccount: "Don't Have An Account Yet?",
        authRegisterNow: "Register Now",
        authHaveAccount: "Already Have An Account?",
        authLogInLink: "Log In",
        authOrSignUpWith: "Or Sign Up With",
        authFullNamePlaceholder: "Full Name (Username)",
        authConfirmPasswordPlaceholder: "Confirm Password",
        authBirthdayLabel: "Birthday",
        authBirthplaceLabel: "Birthplace",
        authBirthplacePlaceholder: "e.g., Beijing, China",
        authBirthTimeLabel: "Birth Time",
        authAgreeTerms: "I Agree To",
        authTermsOfService: "THE TERMS OF SERVICE",
        authAnd: "And",
        authPrivacyPolicy: "PRIVACY POLICY",
        authStartJourney: "START YOUR JOURNEY",
        authVerifyDescription: (email: string) => `ENTER THE CODE GENERATED FROM THE LINK SENT TO ${email || 'XXX@YY.COM'}`,
        authVerificationPlaceholder: "verification code",
        authVerify: "verify",

        // Auth validation errors
        authEmailRequired: "Email is required",
        authUsernameOrEmailRequired: "Username or email is required",
        authInvalidEmail: "Invalid email address",
        authPasswordRequired: "Password is required",
        authPasswordTooShort: "Password must be at least 6 characters",
        authConfirmPasswordRequired: "Confirm password is required",
        authPasswordsNotMatch: "Passwords do not match",
        authFullNameRequired: "Full name is required",
        authAgreeTermsRequired: "Please agree to the terms of service",
        authLoginFailed: "Login failed, please check your username and password",
        authSignUpFailed: "Sign up failed, please check your information",
        authSignUpSuccess: "Sign up successful! Please log in",

        // Policy content
        policyTermsTitle: "TERMS OF SERVICE",
        policyPrivacyTitle: "PRIVACY POLICY",
        policySubtitle: "Spread Overview",

        // User Center page
        userCenterBack: "Back",
        userCenterLoading: "Loading...",
        userCenterBalance: "Balance",
        userCenterRedeemPlaceholder: "Type Your Redemption Code",
        userCenterRedeemNow: "REDEEM NOW",
        userCenterRedeeming: "REDEEMING...",
        userCenterRedeemSuccess: (amount: number) => `Redeem successful! Received ${amount} DCOIN`,
        userCenterRedeemSuccessVip: (level: string) => `Redeem successful! Upgraded to ${level} Member`,
        userCenterRedeemSuccessGeneral: "Redeem successful!",
        userCenterRedeemCodeRequired: "Please enter redemption code",
        userCenterPleaseLogin: "Please login first",
        userCenterValidating: "Validating code...",
        userCenterRedeemFailed: "Redeem failed, please check the code",
        userCenterRechargeCenter: "Recharge Center",
        userCenterDivinationHistory: "Divination History",
        userCenterLogout: "→ LOG OUT",

        // TopUp page
        topUpTitle: "RECHARGE CENTER",
        topUpSubtitle: "Unlock Membership Privileges Or Purchase Tokens",
        topUpTokenTab: "TOKEN TOP-UP",
        topUpHistoryTab: "TOP-UP HISTORY",
        topUpPremiumPackage: "Premium Package",
        topUpBonusFromPackage: "Bonus from Package",
        topUpBonusFromPlan: "Bonus from your Master Plan",
        topUpBuyNow: "Buy Now",
        topUpProcessing: "Processing...",
        topUpPaymentSuccess: (amount: number) => `Payment Successful! Added ${amount} DCoins to your account.`,
        topUpPaymentNetworkError: "Payment successful, but we couldn't update your balance right now due to a network error. \n\nDon't worry! Your transaction record is saved locally. Please refresh the page or visit this page later to automatically retry.",
        topUpPaymentNoUser: "Payment successful, but user info not found. Please re-login. Your transaction is saved and will retry upon login.",
        topUpRecovered: (amount: number) => `Recovered missing purchase! Added ${amount} DCoins.`,
        topUpFreePlan: "This plan is free!",
        topUpSubscriptionActivated: (planId: string) => `Payment Successful! Subscription ${planId} activated.`,
        topUpBack: "Back",
        topUpCurrentBalance: "Current Balance",
        topUpLoading: "Loading...",

        // Daily Reward
        dailyRewardTitle: "Daily Reward",
        dailyRewardMessage: "You received 100 DCOIN!",
        dailyRewardClaim: "Claim",
        dailyRewardAlreadyClaimed: "Already claimed today",

        // FortuneHistory page
        fortuneHistoryTitle: "DIVINATION HISTORY",
        fortuneHistorySubtitle: "A Record Of Your Past Readings And Revealed Insights",
        fortuneHistoryKeepAsking: "KEEP ASKING",
        fortuneHistoryViewFull: "VIEW FULL READING",
    },
    zh: {
        login: '登录',
        reversed: '逆位',
        upright: '正位',
        hexagram: '卦象',
        reversedMeaning: '逆位释义',
        uprightMeaning: '正位释义',
        hexagramMeaning: '卦象释义',
        coreKeywords: '核心关键词',
        keyword1: '关键词 1',
        keyword2: '关键词 2',
        keyword3: '关键词 3',
        inputPlaceholderTarot: "我的财运能量如何？",
        inputPlaceholderIChing: "询问卦象的智慧...",
        deepReading: '深度解读',
        fastReading: '快速解读',
        insufficientCoins: "金币不足，请充值后继续。",
        transactionFailed: "交易失败，请重试。",
        spiritsSilent: "神灵沉默了，请重试。",
        connectionInterrupted: "连接中断，请重试。",
        thinking: "思考中...",
        tarotGreeting: (cardName: string, isReversed: boolean) => `你好。这张牌通常暗示着${isReversed ? '挑战' : '新的开始'}。我们需要探讨它揭示了你目前的什么处境吗？`,
        ichingGreeting: (cardName: string) => `你好。${cardName}卦显现。这古老的智慧诉说着变化与平衡。你想了解关于你道路的什么指引？`,
        tarotStatic: (cardName: string, isReversed: boolean) => `${cardName} ${isReversed ? '逆位' : '正位'} 代表...`,
        ichingStatic: "此卦象关联...",
        promptContextFast: (info: string, msg: string) => `背景：用户抽到/收到 ${info}。用户问："${msg}"。请用简短的一段话概括回答。`,
        promptContextDeep: (info: string, msg: string, wisdom: string) => `背景：用户抽到/收到 ${info}。用户问："${msg}"。请基于${wisdom}的智慧，提供深入、详细的神秘学解读。`,
        promptContextHistory: (info: string, msg: string, type: string, isFast: boolean) => `背景：用户抽到/收到 ${info}。之前已有对话历史。用户问："${msg}"。请以${type}的身份回答。${isFast ? '请用简短的一段话概括回答。' : '请提供详细的神秘学解读。'}`,
        languagePrompt: " Answer in Chinese (Mandarin).",
        invalidCardType: "无效的牌类型",
        selectLanguage: "选择语言",
        tarotQuestions: [
            "这张牌揭示了我目前的什么处境？",
            "我如何克服前方的挑战？",
            "我应该注意哪些机会？",
            "什么阻碍了我的进步？",
            "我如何改善我的人际关系？",
            "我应该专注于哪些个人成长？",
            "我的爱情生活周围有什么能量？",
            "我如何与高我保持一致？",
            "什么职业道路最适合我？",
            "我如何找到内心的平静？",
            "我的直觉想告诉我什么？",
            "我该如何更好地管理我的资源？",
            "如果我冒这个险，结果会如何？",
            "谁或什么正在影响我当前的道路？",
            "为了前进，我应该通过放下什么？",
        ],
        ichingQuestions: [
            "这个卦象揭示了我目前的什么处境？",
            "我如何克服前方的挑战？",
            "我应该注意哪些机会？",
            "宇宙在教导我什么？",
            "我如何在生活中找到更多平衡？",
            "我有什么隐藏的潜力？",
            "现在最好的行动方案是什么？",
            "我应该如何处理这段关系？",
            "我的事业即将发生什么变化？",
            "我如何培养更好的运气？",
            "这种情况的根本原因是什么？",
            "我如何最好地适应这些变化？",
            "处理这种冲突的明智方法是什么？",
            "这种情况如何与我的命运保持一致？",
            "我今天可以迈出哪一小步来获得大结果？",
        ],
        // NfcRead page
        scanText1: "将卡片放在手机背面",
        scanText2: "感应它的能量",
        tapToToggle: "点击切换正位/逆位",
        confirmButton: "确认并开始解读",

        // Auth page
        authOnlineDivination: "在线占卜",
        authWelcomeBack: "欢迎回来",
        authCreateAccount: "创建账户",
        authWelcome: "欢迎",
        authEmailLabel: "邮箱地址",
        authEmailPlaceholder: "your@gmail.com",
        authPasswordLabel: "密码",
        authPasswordPlaceholder: "请输入密码",
        authLogIn: "登录",
        authLoggingIn: "登录中...",
        authSignUp: "注册",
        authSigningUp: "注册中...",
        authGoogle: "谷歌",
        authAppleId: "苹果账号",
        authNoAccount: "还没有账户？",
        authRegisterNow: "立即注册",
        authHaveAccount: "已有账户？",
        authLogInLink: "登录",
        authOrSignUpWith: "或使用以下方式注册",
        authFullNamePlaceholder: "全名（用户名）",
        authConfirmPasswordPlaceholder: "确认密码",
        authBirthdayLabel: "生日",
        authBirthplaceLabel: "出生地",
        authBirthplacePlaceholder: "例如：北京，中国",
        authBirthTimeLabel: "出生时间",
        authAgreeTerms: "我同意",
        authTermsOfService: "服务条款",
        authAnd: "和",
        authPrivacyPolicy: "隐私政策",
        authStartJourney: "开始您的旅程",
        authVerifyDescription: (email: string) => `请输入发送到 ${email || 'XXX@YY.COM'} 的验证码`,
        authVerificationPlaceholder: "验证码",
        authVerify: "验证",

        // Auth validation errors
        authEmailRequired: "请输入邮箱",
        authUsernameOrEmailRequired: "请输入用户名或邮箱",
        authInvalidEmail: "邮箱地址格式无效",
        authPasswordRequired: "请输入密码",
        authPasswordTooShort: "密码至少需要6个字符",
        authConfirmPasswordRequired: "请确认密码",
        authPasswordsNotMatch: "两次密码输入不一致",
        authFullNameRequired: "请输入全名",
        authAgreeTermsRequired: "请同意服务条款",
        authLoginFailed: "登录失败，请检查用户名和密码",
        authSignUpFailed: "注册失败，请检查输入信息",
        authSignUpSuccess: "注册成功！请登录",

        // Policy content
        policyTermsTitle: "服务条款",
        policyPrivacyTitle: "隐私政策",
        policySubtitle: "概述",

        // User Center page
        userCenterBack: "返回",
        userCenterLoading: "加载中...",
        userCenterBalance: "余额",
        userCenterRedeemPlaceholder: "输入您的兑换码",
        userCenterRedeemNow: "立即兑换",
        userCenterRedeeming: "兑换中...",
        userCenterRedeemSuccess: (amount: number) => `兑换成功！获得 ${amount} DCOIN`,
        userCenterRedeemSuccessVip: (level: string) => `兑换成功！升级为 ${level} 会员`,
        userCenterRedeemSuccessGeneral: "兑换成功！",
        userCenterRedeemCodeRequired: "请输入兑换码",
        userCenterPleaseLogin: "请先登录",
        userCenterValidating: "正在校验兑换码...",
        userCenterRedeemFailed: "兑换失败，请检查兑换码",
        userCenterRechargeCenter: "充值中心",
        userCenterDivinationHistory: "占卜记录",
        userCenterLogout: "→ 退出登录",

        // TopUp page
        topUpTitle: "充值中心",
        topUpSubtitle: "解锁会员权益或购买代币",
        topUpTokenTab: "代币充值",
        topUpHistoryTab: "充值记录",
        topUpPremiumPackage: "高级套餐",
        topUpBonusFromPackage: "套餐赠送",
        topUpBonusFromPlan: "会员权益赠送",
        topUpBuyNow: "立即购买",
        topUpProcessing: "处理中...",
        topUpPaymentSuccess: (amount: number) => `支付成功！已添加 ${amount} DCoins 到您的账户。`,
        topUpPaymentNetworkError: "支付成功，但由于网络错误暂时无法更新您的余额。\\n\\n请放心！您的交易记录已保存在本地。请刷新页面或稍后访问此页面自动重试。",
        topUpPaymentNoUser: "支付成功，但未找到用户信息。请重新登录。您的交易已保存，登录后会自动重试。",
        topUpRecovered: (amount: number) => `已恢复遗失的购买！添加了 ${amount} DCoins。`,
        topUpFreePlan: "此方案是免费的！",
        topUpSubscriptionActivated: (planId: string) => `支付成功！订阅 ${planId} 已激活。`,
        topUpBack: "返回",
        topUpCurrentBalance: "当前余额",
        topUpLoading: "加载中...",

        // Daily Reward
        dailyRewardTitle: "每日奖励",
        dailyRewardMessage: "您获得了 100 DCOIN！",
        dailyRewardClaim: "领取",
        dailyRewardAlreadyClaimed: "今日已领取",

        // FortuneHistory page
        fortuneHistoryTitle: "占卜记录",
        fortuneHistorySubtitle: "您过去的解读和洞察记录",
        fortuneHistoryKeepAsking: "继续提问",
        fortuneHistoryViewFull: "查看完整解读",
    }
};
